import { render, staticRenderFns } from "./InstitutionCard.vue?vue&type=template&id=4272e69a&"
import script from "./InstitutionCard.vue?vue&type=script&lang=ts&"
export * from "./InstitutionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports